(function () {
  'use strict';

  var LIGHTBOX_ID = 'bd-product-lightbox';

  function parseGalleryData(root) {
    var script = root.querySelector('[data-bd-gallery-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('[bd-product-lightbox] Invalid gallery JSON', error);
      return null;
    }
  }

  function buildLightbox() {
    var existing = document.getElementById(LIGHTBOX_ID);
    if (existing) return existing;

    var root = document.createElement('div');
    root.id = LIGHTBOX_ID;
    root.className = 'bd-product-lightbox';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('aria-label', 'Product image viewer');
    root.hidden = true;

    root.innerHTML =
      '<button type="button" class="bd-product-lightbox__backdrop" data-bd-lightbox-backdrop aria-label="Close image viewer"></button>' +
      '<div class="bd-product-lightbox__dialog">' +
      '  <div class="bd-product-lightbox__header">' +
      '    <p class="bd-product-lightbox__count" data-bd-lightbox-count>Image 1 of 1</p>' +
      '    <div class="bd-product-lightbox__controls-top">' +
      '      <button type="button" class="bd-product-lightbox__btn" data-bd-lightbox-zoom aria-pressed="false">Zoom</button>' +
      '      <button type="button" class="bd-product-lightbox__btn bd-product-lightbox__btn--icon" data-bd-lightbox-close aria-label="Close image viewer">&times;</button>' +
      '    </div>' +
      '  </div>' +
      '  <div class="bd-product-lightbox__stage" data-bd-lightbox-stage>' +
      '    <button type="button" class="bd-product-lightbox__btn bd-product-lightbox__nav bd-product-lightbox__nav--prev" data-bd-lightbox-prev aria-label="Previous image">&#8249;</button>' +
      '    <img class="bd-product-lightbox__image" data-bd-lightbox-image alt="" decoding="async">' +
      '    <button type="button" class="bd-product-lightbox__btn bd-product-lightbox__nav bd-product-lightbox__nav--next" data-bd-lightbox-next aria-label="Next image">&#8250;</button>' +
      '  </div>' +
      '  <div class="bd-product-lightbox__footer">' +
      '    <p class="bd-product-lightbox__hint" data-bd-lightbox-hint>Click image or Zoom to inspect details. Press Escape to close.</p>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(root);
    return root;
  }

  function ProductLightbox() {
    this.lightbox = buildLightbox();
    this.stage = this.lightbox.querySelector('[data-bd-lightbox-stage]');
    this.image = this.lightbox.querySelector('[data-bd-lightbox-image]');
    this.count = this.lightbox.querySelector('[data-bd-lightbox-count]');
    this.hint = this.lightbox.querySelector('[data-bd-lightbox-hint]');
    this.closeBtn = this.lightbox.querySelector('[data-bd-lightbox-close]');
    this.zoomBtn = this.lightbox.querySelector('[data-bd-lightbox-zoom]');
    this.prevBtn = this.lightbox.querySelector('[data-bd-lightbox-prev]');
    this.nextBtn = this.lightbox.querySelector('[data-bd-lightbox-next]');
    this.backdrop = this.lightbox.querySelector('[data-bd-lightbox-backdrop]');

    this.images = [];
    this.currentIndex = 0;
    this.isOpen = false;
    this.isZoomed = false;
    this.lastTrigger = null;
    this.activeGallery = null;

    this.bindEvents();
    this.initGalleries();
  }

  ProductLightbox.prototype.bindEvents = function () {
    var self = this;

    this.closeBtn.addEventListener('click', function () {
      self.close();
    });
    this.backdrop.addEventListener('click', function () {
      self.close();
    });
    this.prevBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      self.showPrevious();
    });
    this.nextBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      self.showNext();
    });
    this.zoomBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      self.toggleZoom();
    });
    this.image.addEventListener('click', function (event) {
      event.stopPropagation();
      self.toggleZoom();
    });

    document.addEventListener('keydown', function (event) {
      if (!self.isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        self.close();
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.showPrevious();
        return;
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.showNext();
      }
    });
  };

  ProductLightbox.prototype.initGalleries = function () {
    var self = this;
    var galleries = document.querySelectorAll('[data-bd-product-gallery]');
    var hoverPreviewEnabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    galleries.forEach(function (gallery) {
      var data = parseGalleryData(gallery);
      if (!data || !data.images || !data.images.length) return;

      gallery._bdGalleryData = data;
      gallery._bdSelectedIndex =
        typeof data.selectedIndex === 'number' ? data.selectedIndex : self.findSelectedIndex(gallery, data);

      var thumbs = gallery.querySelectorAll('[data-bd-gallery-thumb]');
      var thumbsContainer = gallery.querySelector('.baxter-product-main__thumbs');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          var index = parseInt(thumb.getAttribute('data-media-index'), 10);
          if (Number.isNaN(index)) return;
          self.selectThumb(gallery, index);
        });

        thumb.addEventListener('focus', function () {
          var index = parseInt(thumb.getAttribute('data-media-index'), 10);
          if (Number.isNaN(index)) return;
          self.previewThumb(gallery, index);
        });

        if (hoverPreviewEnabled) {
          thumb.addEventListener('mouseenter', function () {
            var index = parseInt(thumb.getAttribute('data-media-index'), 10);
            if (Number.isNaN(index)) return;
            self.previewThumb(gallery, index);
          });

          thumb.addEventListener('mouseleave', function () {
            thumb.classList.remove('is-preview');
          });
        }
      });

      if (thumbsContainer) {
        if (hoverPreviewEnabled) {
          thumbsContainer.addEventListener('mouseleave', function () {
            self.clearThumbPreviews(gallery);
            self.revertToSelected(gallery);
          });
        }

        thumbsContainer.addEventListener('focusout', function (event) {
          if (!thumbsContainer.contains(event.relatedTarget)) {
            self.clearThumbPreviews(gallery);
            self.revertToSelected(gallery);
          }
        });
      }

      var openTrigger = gallery.querySelector('[data-bd-gallery-open]');
      if (openTrigger) {
        openTrigger.addEventListener('click', function (event) {
          event.preventDefault();
          self.open(gallery, self.getOpenIndex(gallery), openTrigger);
        });
      }
    });
  };

  ProductLightbox.prototype.findSelectedIndex = function (gallery, data) {
    var activeThumb = gallery.querySelector('[data-bd-gallery-thumb][aria-current="true"]');
    if (!activeThumb) {
      activeThumb = gallery.querySelector('[data-bd-gallery-thumb].is-active');
    }
    if (activeThumb) {
      var index = parseInt(activeThumb.getAttribute('data-media-index'), 10);
      if (!Number.isNaN(index)) return index;
    }
    return 0;
  };

  ProductLightbox.prototype.updateMainImage = function (gallery, index) {
    var data = gallery._bdGalleryData || parseGalleryData(gallery);
    if (!data || !data.images[index]) return null;

    var imageData = data.images[index];
    var mainImage = gallery.querySelector('.baxter-product-main__image');
    if (mainImage) {
      mainImage.src = imageData.mainUrl;
      mainImage.alt = imageData.alt || data.productTitle || '';
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
    }

    return imageData;
  };

  ProductLightbox.prototype.previewThumb = function (gallery, index) {
    var data = gallery._bdGalleryData || parseGalleryData(gallery);
    if (!data || !data.images[index]) return;

    this.updateMainImage(gallery, index);
    gallery._bdPreviewIndex = index;

    gallery.querySelectorAll('[data-bd-gallery-thumb]').forEach(function (thumb) {
      var thumbIndex = parseInt(thumb.getAttribute('data-media-index'), 10);
      thumb.classList.toggle('is-preview', thumbIndex === index);
    });
  };

  ProductLightbox.prototype.clearThumbPreviews = function (gallery) {
    gallery.querySelectorAll('[data-bd-gallery-thumb].is-preview').forEach(function (thumb) {
      thumb.classList.remove('is-preview');
    });
  };

  ProductLightbox.prototype.revertToSelected = function (gallery) {
    var index = typeof gallery._bdSelectedIndex === 'number' ? gallery._bdSelectedIndex : 0;
    gallery._bdPreviewIndex = null;
    this.updateMainImage(gallery, index);
  };

  ProductLightbox.prototype.getOpenIndex = function (gallery) {
    if (typeof gallery._bdPreviewIndex === 'number') {
      return gallery._bdPreviewIndex;
    }
    return typeof gallery._bdSelectedIndex === 'number' ? gallery._bdSelectedIndex : 0;
  };

  ProductLightbox.prototype.selectThumb = function (gallery, index) {
    var data = gallery._bdGalleryData || parseGalleryData(gallery);
    if (!data || !data.images[index]) return;

    gallery._bdGalleryData = data;
    gallery._bdSelectedIndex = index;

    this.clearThumbPreviews(gallery);
    this.updateMainImage(gallery, index);
    gallery._bdPreviewIndex = null;

    gallery.querySelectorAll('[data-bd-gallery-thumb]').forEach(function (thumb) {
      var thumbIndex = parseInt(thumb.getAttribute('data-media-index'), 10);
      var isActive = thumbIndex === index;
      thumb.classList.toggle('is-active', isActive);
      if (isActive) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });

    var openTrigger = gallery.querySelector('[data-bd-gallery-open]');
    if (openTrigger) {
      var imageData = data.images[index];
      var label = imageData.alt || data.productTitle || 'product image';
      openTrigger.setAttribute('aria-label', 'View larger product image: ' + label);
    }
  };

  ProductLightbox.prototype.open = function (gallery, index, trigger) {
    var data = gallery._bdGalleryData || parseGalleryData(gallery);
    if (!data || !data.images.length) return;

    this.activeGallery = gallery;
    this.images = data.images;
    this.currentIndex = Math.max(0, Math.min(index, this.images.length - 1));
    this.lastTrigger = trigger || null;
    this.isOpen = true;
    this.setZoom(false);

    this.lightbox.hidden = false;
    this.lightbox.classList.add('is-open');
    this.lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bd-lightbox-open');

    this.renderImage();
    this.closeBtn.focus();
  };

  ProductLightbox.prototype.close = function () {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.setZoom(false);
    this.lightbox.classList.remove('is-open');
    this.lightbox.setAttribute('aria-hidden', 'true');
    this.lightbox.hidden = true;
    document.body.classList.remove('bd-lightbox-open');

    if (this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
      this.lastTrigger.focus();
    }
    this.lastTrigger = null;
  };

  ProductLightbox.prototype.renderImage = function () {
    var imageData = this.images[this.currentIndex];
    if (!imageData) return;

    this.image.src = imageData.fullUrl || imageData.mainUrl;
    this.image.alt = imageData.alt || '';
    this.count.textContent = 'Image ' + (this.currentIndex + 1) + ' of ' + this.images.length;

    var hasMultiple = this.images.length > 1;
    this.prevBtn.hidden = !hasMultiple;
    this.nextBtn.hidden = !hasMultiple;
    this.prevBtn.disabled = !hasMultiple;
    this.nextBtn.disabled = !hasMultiple;

    this.hint.textContent = hasMultiple
      ? 'Use arrow keys or buttons to browse. Click image or Zoom to inspect details. Press Escape to close.'
      : 'Click image or Zoom to inspect details. Press Escape to close.';
  };

  ProductLightbox.prototype.showPrevious = function () {
    if (!this.images.length) return;
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.setZoom(false);
    this.renderImage();
  };

  ProductLightbox.prototype.showNext = function () {
    if (!this.images.length) return;
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.setZoom(false);
    this.renderImage();
  };

  ProductLightbox.prototype.toggleZoom = function () {
    this.setZoom(!this.isZoomed);
  };

  ProductLightbox.prototype.setZoom = function (enabled) {
    this.isZoomed = enabled;
    this.stage.classList.toggle('is-zoomed', enabled);
    this.zoomBtn.setAttribute('aria-pressed', enabled ? 'true' : 'false');
    this.zoomBtn.textContent = enabled ? 'Fit' : 'Zoom';
    this.zoomBtn.setAttribute('aria-label', enabled ? 'Fit image to screen' : 'Zoom image to original size');

    if (!enabled) {
      this.stage.scrollTop = 0;
      this.stage.scrollLeft = 0;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      new ProductLightbox();
    });
  } else {
    new ProductLightbox();
  }
})();
